import React, { Component } from "react";

import Login from "../components/Login";

class LoginView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount(){
    window.addEventListener("click", this.closeAllDropDown.bind(this));
  }

  componentWillUnmount(){
    window.removeEventListener("click", this.closeAllDropDown.bind(this))
  }

  closeAllDropDown(e) {
    let ignoreElement = null;

    if(e &&
      e.target &&
      e.target.dataset &&
      e.target.dataset.target){
        ignoreElement = document.getElementById(e.target.dataset.target);
      }

      let clickInside = ignoreElement ? ignoreElement.contains(e.target) : false;

      if (!clickInside) {
        let menu = document.getElementsByClassName("dropdown-menu");
        for (let c = 0; c < menu.length; c++) {
          if (menu[c].classList && menu[c].classList.contains("user-type-menu")) {
            menu[c].classList.remove("user-type-menu");
          }
        }
      }
  }

  render() {
    return (
      <>
        <div className="page-login">
          <Login />
        </div>

        <link
          href="https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400;1,600;1,700&display=swap"
          rel="stylesheet"
        />
      </>
    );
  }
}

export default LoginView;
